import React from "react";


const TailwindSwitch = ({ isDisabled, action, data, isChecked }) => {
  return (
    <div className="flex items-center ml-2 space-x-2">
      <label className="flex items-center space-x-2">
        <label className="relative inline-flex items-center cursor-pointer">
          <input
            type="checkbox"
            checked={isChecked}
            disabled={isDisabled}
            onChange={(e) => action(e, data)}
            className="sr-only peer"
            name="publishSwitch"
          />

          {/* Track */}
          <div
            className={`w-11 h-6 rounded-full border transition-all duration-200
              ${isDisabled
                ? "bg-gray-300 dark:bg-gray-700 border-gray-300 dark:border-gray-600 cursor-not-allowed"
                : "bg-gray-200 dark:bg-gray-800 border-gray-400 dark:border-gray-600 peer-checked:bg-[#3b83f6] dark:peer-checked:bg-[#3b83f6]"
              }
              peer-focus:outline-none peer-focus:ring-2 peer-focus:ring-blue-500 dark:peer-focus:ring-blue-400`}
          ></div>

          {/* Thumb */}
          <div
            className={`absolute left-0.5 top-0.5 w-5 h-5 bg-white dark:bg-gray-200 rounded-full transition-transform duration-200 transform peer-checked:translate-x-full
              ${isDisabled ? "opacity-50" : ""}`}
          ></div>
        </label>
      </label>
    </div>
  );
};

export default TailwindSwitch;